import React from 'react';

const PropertyReg = () => {
  return (
    <div className="bg-[#f6f6f2]  min-h-screen p-6 font-sans">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <header className="text-center mb-12">
                 <h1 className="text-3xl md:text-4xl font-bold text-center text-[#333333] mb-10 border-b-2 pb-2 border-[#b7b7a1]">
PROPERTY REGTRATION</h1>
          <h2 className="text-2xl font-semibold text-gray-800">Sale Agreement Registration</h2>
          <p className="text-lg text-gray-600">Registering a sale agreement involves several steps and adherence to specific legal requirements.</p>
        </header>
              <p className="text-md text-justify text-[#444] mb-8">Our highly experienced legal team excels in drafting a variety of essential documents for property registration, ensuring a seamless experience for our customers. With a deep understanding of property law, our lawyers skillfully prepare sales agreements, transfer deeds, and mortgage documents, tailored to each client's unique needs. Supported by our expert staff, who provide comprehensive end-to-end assistance, we guide clients through the entire registration process. From initial documentation to final submissions, our dedicated team is committed to delivering timely and accurate services, alleviating the complexities often associated with property registration. By prioritizing customer satisfaction and leveraging our expertise, we ensure that every client's property transaction is handled with utmost professionalism and legal precision</p>

        {/* Sale Agreement Section */}
        <section className="mb-12">
          <h3 className="text-xl font-semibold text-[#b7b7a1]">Process for Registering a Sale Agreement:</h3>
          <ol className="list-decimal pl-5 space-y-4">
            <li>
              <strong className="text-gray-800">Draft the Sale Agreement:</strong>
              <p className="text-gray-700">
                The first step is to draft the sale agreement. This document should include details such as the names and addresses of the buyer and seller, description of the property, agreed-upon price, and other terms and conditions of the sale.
                It is advisable to have the agreement drafted or reviewed by a legal professional to ensure it complies with local laws and regulations.
              </p>
            </li>
            <li>
              <strong className="text-gray-800">Stamp Duty Payment:</strong>
              <p className="text-gray-700">
                The appropriate stamp duty must be paid before the agreement can be registered. The amount of stamp duty varies from state to state and is calculated based on the property's value.
                The stamp duty can be paid online to the treasury or through e-stamping facilities in Karnataka.
              </p>
            </li>
            <li>
              <strong className="text-gray-800">Visit the Sub-Registrar's Office:</strong>
              <p className="text-gray-700">
                The buyer, seller, and two witnesses must visit the local Sub-Registrar's Office in the jurisdiction where the property is located.
                Both parties must carry original identity proofs (such as Aadhaar, PAN card, passport, etc.) and copies.
              </p>
            </li>
            <li>
              <strong className="text-gray-800">Submit the Documents:</strong>
              <p className="text-gray-700">The following documents need to be submitted to the Sub-Registrar's Office:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Original sale agreement</li>
                <li>Receipt of stamp duty payment</li>
                <li>Identity proofs of the buyer, seller, and witnesses</li>
                <li>Property documents (such as title deeds, property cards, etc.)</li>
              </ul>
            </li>
            <li>
              <strong className="text-gray-800">Biometric Verification:</strong>
              <p className="text-gray-700">
                In Karnataka, biometric verification (fingerprints) of the buyer, seller, and witnesses may be required.
              </p>
            </li>
            <li>
              <strong className="text-gray-800">Registration Process:</strong>
              <p className="text-gray-700">
                The Sub-Registrar will verify the documents and, if everything is in order, will proceed with the registration.
                The buyer and seller will be required to sign the agreement in the presence of the Sub-Registrar and the witnesses.
              </p>
            </li>
            <li>
              <strong className="text-gray-800">Receipt of Registered Document:</strong>
              <p className="text-gray-700">
                After registration, the Sub-Registrar will provide a receipt and return the registered sale agreement to the parties.
                The registered agreement will bear the Sub-Registrar's signature and seal.
              </p>
            </li>
            <li>
              <strong className="text-gray-800">Post-Registration Steps:</strong>
              <p className="text-gray-700">
                Keeping multiple copies of the registered sale agreement for future reference is advisable.
                The buyer should also ensure that the property's title is transferred in their name at the relevant municipal or land records office.
              </p>
            </li>
          </ol>
        </section>

        {/* Additional Considerations */}
        <section className="mb-12">
          <h3 className="text-xl font-semibold text-[#b7b7a1]">Additional Considerations:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Time Frame: The registration process typically takes a few hours to a day but can vary depending on the Sub-Registrar's Office workload.</li>
            <li>Fees: Apart from stamp duty, additional registration fees and other charges may need to be paid.</li>
            <li>Legal Assistance: Our legal team will help navigate the process smoothly and ensure compliance with all legal requirements.</li>
          </ul>
        </section>

        {/* Important Note */}
        <section className="mb-12">
          <p className="text-red-600 font-semibold">Important Note:</p>
          <p className="text-gray-700">It is crucial to check the specific guidelines and regulations applicable in Karnataka before proceeding with the registration of a sale agreement. Our legal team will take care of it.</p>
        </section>

        {/* Sale Deed Section */}
        <section className="mt-12">
          <h2 className="text-2xl font-semibold text-gray-800">SALE DEED</h2>
          <p className="text-gray-700">Property registration involves submitting various documents to the local sub-registrar's office to ensure the legality and validity of the transaction.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Common Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Sale Deed or Conveyance Deed: The primary document that outlines the terms of the property transfer, duly signed by both the buyer and the seller.</li>
            <li>Stamp Duty and Registration Fees: Payment receipts per the state’s regulations.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Seller’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the seller.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the seller.</li>
            <li>Title Deed: The original document that proves ownership of the property.</li>
            <li>Encumbrance Certificate: A certificate issued by the sub-registrar’s office that shows no legal dues, mortgages, or loans on the property.</li>
            <li>Property Tax Receipts: To show that all property taxes have been paid.</li>
            <li>No Objection Certificate (NOC): From the housing society or any other relevant authority, if applicable.</li>
            <li>Approved Building Plan: If the property is a constructed building, the approved plan is from the municipal corporation or local authority.</li>
            <li>Possession Certificate: To confirm that the seller has physical possession of the property.</li>
            <li>Latest Electricity Bill and Water Bill: To confirm the address and usage of the property.</li>
            <li>Completion Certificate: Issued by the local authority if the property is a newly constructed building.</li>
            <li>Occupancy Certificate: Issued by the local authority to certify that the building is ready for occupancy.</li>
            <li>Power of Attorney: If the property is being sold by someone holding a power of attorney on behalf of the owner.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Buyer’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the buyer.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the buyer.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Witnesses’ Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of at least two witnesses.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the witnesses.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Additional Documents (if applicable):</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>NOC from Bank: A No Objection Certificate from the bank is required if the property is under mortgage or loan.</li>
            <li>Family Settlement Deed: If the property is transferred as part of a family settlement.</li>
            <li>Death Certificate and Succession Certificate: If legal heirs sell the property after the owner's death.</li>
            <li>Conversion Certificate: If agricultural land is converted for non-agricultural use.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Legal Checks:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Title Search: To verify the ownership history and ensure the title is clear.</li>
            <li>Verification of Documents: All documents should be verified for authenticity.</li>
            <li>Legal Opinion: Obtaining a legal opinion from a lawyer to ensure that the sale deed and other documents are legally sound and cover all necessary aspects.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Registration Process:</h3>
          <ol className="list-decimal pl-5 space-y-2">
            <li>Visit the Sub Registrar’s Office: The buyer, seller, and witnesses must visit the local Sub Registrar’s office.</li>
            <li>Submit Documents: All the required documents must be submitted to the sub-registrar.</li>
            <li>Biometric Verification: Biometric verification of the parties involved is required.</li>
            <li>Payment of Fees: The stamp duty and registration fees must be paid.</li>
            <li>Registration: The sub-registrar will register the property and issue a registration certificate.</li>
          </ol>

          <p className="text-gray-700 mt-4">Our Legal Team will ensure that all documents are in order and adequately verified before proceeding with the property registration to avoid delays or legal issues.</p>
        </section>

        {/* Release Deed Section */}
        <section className="mt-12">
          <h2 className="text-2xl font-semibold text-gray-800">RELEASE DEED</h2>
          <p className="text-gray-700">Preparing a Release Deed within a family in India involves several documents to ensure the legality and validity of releasing rights or claims over a property.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Releasor’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the releasor.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the releasor.</li>
            <li>Photograph: Recent passport-sized photograph of the releasor.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Releasee’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the releasee.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the releasee.</li>
            <li>Photograph: Recent passport-sized photograph of the releasee.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Draft Release Deed:</h3>
          <p className="text-gray-700">Our Legal team will draft the document that outlines the terms and conditions of the release, specifying the property involved, the relationship between the releasor and the releasee, and any other relevant details. The Release Deed should be dated and signed by the releasor.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Property Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Title Deed: The original document that proves ownership of the property involved.</li>
            <li>Encumbrance Certificate: A certificate issued by the sub-registrar’s office that shows there are no legal dues, mortgages, or loans on the property.</li>
            <li>Property Tax Receipts: To show that all property taxes have been paid up to date.</li>
            <li>No Objection Certificate (NOC): From the housing society or any other relevant authority, if applicable.</li>
            <li>Approved Building Plan: If the property is a constructed building, the approved plan from the municipal corporation or local authority.</li>
            <li>Possession Certificate: To confirm that the releasor and/or releasee have physical possession of the property.</li>
            <li>Latest Electricity Bill and Water Bill: To confirm the address and usage of the property.</li>
            <li>Completion Certificate: Issued by the local authority if the property is a newly constructed building.</li>
            <li>Occupancy Certificate: Issued by the local authority to certify that the building is ready for occupancy.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Witnesses’ Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of at least two witnesses.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the witnesses.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Additional Documents (if applicable):</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>NOC from Bank: A No Objection Certificate from the bank is required if the property is under mortgage or loan.</li>
            <li>Family Settlement Deed: If the release is part of a family settlement.</li>
            <li>Death Certificate and Succession Certificate: If the release involves legal heirs after the death of a family member.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Legal Checks:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Title Search: To verify the ownership history and ensure the title is clear.</li>
            <li>Verification of Documents: All documents should be verified for authenticity.</li>
            <li>Legal Opinion: Obtaining a legal opinion from a lawyer to ensure that the Release Deed is legally sound and covers all necessary aspects.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Registration Requirements:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Original Release Deed: Duly signed by the releasor in the presence of two witnesses.</li>
            <li>Stamp Duty and Registration Fees: Payment receipts per the state’s regulations.</li>
            <li>Identity Proof: Aadhaar card, PAN card, or passport of the releasor, releasee, and witnesses.</li>
            <li>Photographs: Passport-sized photographs of the releasor, releasee, and witnesses.</li>
          </ul>

          <p className="text-gray-700 mt-4">Our Legal Team will ensure that all documents are adequately verified before registering the Release Deed to avoid future disputes and legal issues.</p>
        </section>

        {/* Gift Deed within Family Section */}
        <section className="mt-12">
          <h2 className="text-2xl font-semibold text-gray-800">GIFT DEED WITHIN FAMILY</h2>
          <p className="text-gray-700">Preparing a Gift Deed within a family involves several documents to ensure the legality and validity of the property transfer.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Donor’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the donor.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the donor.</li>
            <li>Photograph: Recent passport-sized photograph of the donor.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Draft Gift Deed:</h3>
          <p className="text-gray-700">A detailed document that outlines the terms and conditions of the gift, specifying the property being gifted, the relationship between the donor and the donee, and any other relevant details. The Gift Deed should be dated and signed by the donor. Our Legal Team will draft the Gift Deed based on the information provided by the Donor & Donee.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Property Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Title Deed: The original document proving ownership of the gifted property.</li>
            <li>Encumbrance Certificate: A certificate issued by the sub-registrar’s office that shows no legal dues, mortgages, or loans on the property.</li>
            <li>Property Tax Receipts: To show that all property taxes have been paid.</li>
            <li>No Objection Certificate (NOC): From the housing society or any other relevant authority, if applicable.</li>
            <li>Approved Building Plan: If the property is a constructed building, the approved plan from the municipal corporation or local authority.</li>
            <li>Possession Certificate: To confirm that the donor has physical possession of the property.</li>
            <li>Latest Electricity Bill and Water Bill: To confirm the address and usage of the property.</li>
            <li>Completion Certificate: Issued by the local authority if the property is a newly constructed building.</li>
            <li>Occupancy Certificate: Issued by the local authority to certify that the building is ready for occupancy.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Witnesses’ Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of at least two witnesses.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the witnesses.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Additional Documents (if applicable):</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>NOC from Bank: A No Objection Certificate from the bank is required if the property is under mortgage or loan.</li>
            <li>Family Settlement Deed: If the gift is part of a family settlement.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Legal Checks:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Title Search: To verify the ownership history and ensure the title is clear.</li>
            <li>Verification of Documents: All documents should be verified for authenticity.</li>
            <li>Legal Opinion: Obtaining a legal opinion from a lawyer to ensure that the Gift Deed is legally sound and covers all necessary aspects.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Registration Requirements:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Original Gift Deed: Duly signed by the donor in the presence of two witnesses.</li>
            <li>Stamp Duty and Registration Fees: Payment receipts per the state’s regulations.</li>
            <li>Identity Proof: Aadhaar card, PAN card, or passport of the donor, donee, and witnesses.</li>
            <li>Photographs: Passport-sized photographs of the donor, donee, and witnesses.</li>
          </ul>

          <p className="text-gray-700 mt-4">Our Legal team will verify all documents before registering the Gift Deed to avoid future disputes and legal issues.</p>
        </section>

        {/* Gift Deed Outside Family Section */}
        <section className="mt-12">
          <h2 className="text-2xl font-semibold text-gray-800">GIFT DEED OUTSIDE FAMILY</h2>
          <p className="text-gray-700">Gift Deed outside of the family involves several documents to ensure the legality and validity of the property transfer.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Donor’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the donor.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the donor.</li>
            <li>Photograph: Recent passport-sized photograph of the donor.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Donee’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the donee.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the donee.</li>
            <li>Photograph: Recent passport-sized photograph of the donee.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Draft Gift Deed:</h3>
          <p className="text-gray-700">A detailed document that outlines the terms and conditions of the gift, specifying the property being gifted, the relationship between the donor and the donee, and any other relevant details. The Gift Deed should be dated and signed by the donor.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Property Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Title Deed: The original document proving ownership of the gifted property.</li>
            <li>Encumbrance Certificate: A certificate issued by the sub-registrar’s office that shows no legal dues, mortgages, or loans on the property.</li>
            <li>Property Tax Receipts: To show that all property taxes have been paid.</li>
            <li>No Objection Certificate (NOC): From the housing society or any other relevant authority, if applicable.</li>
            <li>Approved Building Plan: The approved plan is from the local authority if the property is a constructed building.</li>
            <li>Possession Certificate: To confirm that the donor has physical possession of the property.</li>
            <li>Latest Electricity Bill and Water Bill: To confirm the address and usage of the property.</li>
            <li>Completion Certificate: Issued by the local authority if the property is a newly constructed building.</li>
            <li>Occupancy Certificate: Issued by the local authority to certify that the building is ready for occupancy.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Witnesses’ Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of at least two witnesses.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the witnesses.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Additional Documents (if applicable):</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>NOC from Bank: A No Objection Certificate from the bank is required if the property is under mortgage or loan.</li>
            <li>Valuation Report: A valuation report of the gifted property may be required for tax purposes.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Legal Checks:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Title Search: To verify the ownership history and ensure the title is clear.</li>
            <li>Verification of Documents: All documents should be verified for authenticity.</li>
            <li>Legal Opinion: Obtaining a legal opinion from a lawyer to ensure that the Gift Deed is legally sound and covers all necessary aspects.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Tax Implications:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Gift Tax: The donor may need to consider the tax implications under the Income Tax Act. Gifts exceeding ₹50,000 in a financial year from non-relatives may be taxable.</li>
            <li>Capital Gains Tax: If the property is gifted, the donee may be liable for capital gains tax upon subsequent property sale.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Registration Requirements:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Original Gift Deed: Duly signed by the donor in the presence of two witnesses.</li>
            <li>Stamp Duty and Registration Fees: Payment receipts per the state’s regulations.</li>
            <li>Identity Proof: Aadhaar card, PAN card, or passport of the donor, donee, and witnesses.</li>
            <li>Photographs: Passport-sized photographs of the donor, donee, and witnesses.</li>
          </ul>

          <p className="text-gray-700 mt-4">Our Legal team will verify all documents before registering the Gift Deed to avoid future disputes and legal issues.</p>
        </section>

        {/* General Power of Attorney Section */}
        <section className="mt-12">
          <h2 className="text-2xl font-semibold text-gray-800">GENERAL POWER OF ATTORNEY (GPA)</h2>
          <p className="text-gray-700">General Power of Attorney (GPA) requires several documents to ensure the legality and validity of the authorisation.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Principal’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the principal.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the principal.</li>
            <li>Photograph: Recent passport-sized photograph of the principal.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Attorney’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the attorney.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the attorney.</li>
            <li>Photograph: Recent passport-sized photograph of the attorney.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Draft General Power of Attorney:</h3>
          <p className="text-gray-700">Our legal team will draft a detailed document that outlines the powers being granted to the attorney, the duration of the GPA, and any specific conditions or limitations based on the information provided by the executant.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Additional Documents (if applicable):</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Property Documents: If the GPA is for property-related matters, documents such as the title deed, encumbrance certificate, and property tax receipts may be required.</li>
            <li>Business Documents: If the GPA is for business-related matters, documents such as the certificate of incorporation, partnership deed, or other relevant business registration documents may be required.</li>
            <li>NOC from Bank: A No Objection Certificate from the bank may be required if the GPA involves property under mortgage or loan.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Legal Checks:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Verification of Documents: All documents should be verified for authenticity.</li>
            <li>Legal Opinion: Obtaining a legal opinion from our lawyer to ensure that the GPA is legally sound and covers all necessary aspects.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Registration Requirements:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Original GPA: Duly signed by the principal in the presence of two witnesses.</li>
            <li>Stamp Duty and Registration Fees: Payment receipts per the state’s regulations.</li>
            <li>Two Witnesses: Must be present at the time of registration with their identity proofs.</li>
            <li>Biometric of the principal and the attorney will be captured during registration.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Notarisation Requirements:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Original GPA: Duly signed by the principal in the notary's presence.</li>
            <li>Notary Fees: Payment as per the notary’s charges.</li>
            <li>Identity Proof: Aadhaar card, PAN card, or passport of the principal and the attorney.</li>
            <li>Photographs: Passport-sized photographs of the principal and the attorney.</li>
          </ul>

          <p className="text-gray-700 mt-4">Our legal team will ensure all documents are in order and verified adequately before finalising the GPA to avoid future disputes and legal issues.</p>
        </section>

        {/* Partition Deed Section */}
        <section className="mt-12">
          <h2 className="text-2xl font-semibold text-gray-800">PARTITION DEED</h2>
          <p className="text-gray-700">Preparing a partition deed for immovable property involves several documents to ensure the legality and validity of the property division among co-owners.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Common Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Title Deed: The original document that proves ownership of the property. This should be in the names of all co-owners.</li>
            <li>Encumbrance Certificate: A certificate issued by the sub-registrar’s office that shows no legal dues, mortgages, or loans on the property.</li>
            <li>Property Tax Receipts: To show that all property taxes have been paid.</li>
            <li>No Objection Certificate (NOC): From the housing society or any other relevant authority, if applicable.</li>
            <li>Approved Building Plan: If the property is a constructed building, the approved plan from the municipal corporation or local authority.</li>
            <li>Possession Certificate: To confirm that the co-owners possess the property physically.</li>
            <li>Latest Electricity Bill and Water Bill: To confirm the address and usage of the property.</li>
            <li>Completion Certificate: Issued by the local authority if the property is a newly constructed building.</li>
            <li>Occupancy Certificate: Issued by the local authority to certify that the building is ready for occupancy.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Co-Owners’ Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of each co-owner.</li>
            <li>Address Proof: Each co-owner's Aadhaar card, utility bill, or any other government-issued address proof.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Draft Partition Deed:</h3>
          <p className="text-gray-700">A detailed document that outlines the partition's terms and conditions, specifying each co-owner's share and the exact division of the property.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Additional Documents (if applicable):</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>NOC from Bank: A No Objection Certificate from the bank is required if the property is under mortgage or loan.</li>
            <li>Family Settlement Deed: If the partition is part of a family settlement.</li>
            <li>Death Certificate and Succession Certificate: If one of the co-owners has passed away and the partition involves legal heirs.</li>
            <li>Conversion Certificate: If agricultural land is converted for non-agricultural use.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Legal Checks:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Title Search: To verify the ownership history and ensure the title is clear.</li>
            <li>Verification of Documents: All documents should be verified for authenticity.</li>
            <li>Legal Opinion: Our team will provide legal opinion to ensure the partition deed is legally sound and covers all necessary aspects.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Registration Requirements:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Original Partition Deed: Duly signed by all co-owners.</li>
            <li>Stamp Duty and Registration Fees: Payment receipts as per the state’s regulations.</li>
            <li>Two Witnesses: Must be present at the time of registration with their identity proofs.</li>
            <li>Photographs: Passport-sized photographs of all co-owners.</li>
          </ul>

          <p className="text-gray-700 mt-4">Our Legal team will ensure that all documents are in order and verified adequately before registering the partition deed to avoid future disputes and legal issues.</p>
        </section>

        {/* Will Section */}
        <section className="mt-12">
          <h2 className="text-2xl font-semibold text-gray-800">WILL</h2>
          <p className="text-gray-700">Preparing a Will in India requires specific documents to ensure the clarity and legality of the testamentary disposition.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Testator’s Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of the testator.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the testator.</li>
            <li>Photograph: Recent passport-sized photograph of the testator.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Draft Will:</h3>
          <p className="text-gray-700">A detailed document that clearly outlines the testator’s wishes regarding the distribution of their assets, the appointment of executors, and any other specific instructions. The Will should be dated and signed by the testator.</p>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Witnesses’ Documents:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity Proof: Aadhaar card, PAN card, passport, or any other government-issued ID of at least two witnesses.</li>
            <li>Address Proof: Aadhaar card, utility bill, or any other government-issued address proof of the witnesses.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Additional Documents (if applicable):</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>List of Assets: A detailed list of the testator’s assets, including immovable property, bank accounts, investments, and personal belongings.</li>
            <li>Property Documents: If the Will involves immovable property, documents such as title deeds may be referenced in the Will.</li>
            <li>Executor’s Details: Identify and address proof of the person(s) appointed executor(s) of the Will.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Legal Checks:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Verification of Documents: All documents should be verified for authenticity.</li>
            <li>Legal Opinion: Obtaining a legal opinion from a lawyer to ensure that the Will is legally sound and covers all necessary aspects.</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#b7b7a1] mt-4">Registration and Notarization:</h3>
          <p className="text-gray-700">While a Will is not required to be registered or notarised to be legally valid, doing so can enhance its authenticity and make it harder to challenge.</p>

          <h4 className="text-lg font-semibold text-[#b7b7a1] mt-4">Registration:</h4>
          <ul className="list-disc pl-5 space-y-2">
            <li>Original Will: Duly signed by the testator in the presence of two witnesses.</li>
            <li>Stamp Duty and Registration Fees: Payment receipts as per the state’s regulations.</li>
            <li>Identity Proof: Aadhaar card, PAN card, or passport of the testator and the witnesses.</li>
            <li>Biometric Verification: Biometric verification of the testator is required.</li>
          </ul>

          <h4 className="text-lg font-semibold text-[#b7b7a1] mt-4">Notarization:</h4>
          <ul className="list-disc pl-5 space-y-2">
            <li>Original Will: Duly signed by the testator in the notary's presence.</li>
            <li>Notary Fees: Payment as per the notary’s charges.</li>
            <li>Identity Proof: Aadhaar card, PAN card, or testator's passport.</li>
          </ul>

          <p className="text-gray-700 mt-4">Our Legal Team will ensure that all documents are in order and verified adequately before finalising the Will to avoid future disputes and legal issues.</p>
        </section>
      </div>
    </div>
  );
};

export default PropertyReg;       